import { Toast } from "@newsela/angelou";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";

const yourContentUrl = `${MONOLITH_ORIGIN}/my-content/?tab=saved-by-you`;

export const BOOKMARK_ERROR_TOAST_PROPS = {
  showIcon: true,
  statusColor: Toast.statusColor.danger,
  children: "Oops! We had trouble saving. Please try again",
};

export const BOOKMARK_SUCCESS_TOAST_PROPS = {
  showIcon: true,
  statusColor: Toast.statusColor.success,
  children: "Saved in",
  cta: { href: yourContentUrl, text: "Your Content" },
};

export const UNBOOKMARK_ERROR_TOAST_PROPS = {
  showIcon: true,
  statusColor: Toast.statusColor.success,
  children: "Oops! We had trouble removing the save. Please try again",
};

export const UNBOOKMARK_SUCCESS_TOAST_PROPS = {
  showIcon: true,
  statusColor: Toast.statusColor.primary,
  children: "Removed from",
  cta: { href: yourContentUrl, text: "Your Content" },
};
